import {Injectable} from "@angular/core";
import {Observable, Subject, Subscriber} from "rxjs";
import {deleteVerificationModalActions} from "./const";

@Injectable()
export class DeleteVerificationModalService {
  private warningPopupResultSubscriber$: Subscriber<void> = null;
  private readonly _open$: Subject<string> = new Subject<string>();

  verify(action: deleteVerificationModalActions): void {
    switch (action) {
      case deleteVerificationModalActions.Delete:
        this.warningPopupResultSubscriber$.next();
        this.warningPopupResultSubscriber$.complete();
        break;

      case deleteVerificationModalActions.Cancel:
        this.warningPopupResultSubscriber$.error(undefined);
        break;
    }

    this.warningPopupResultSubscriber$ = null;
  }

  checkWarning(message: string): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.warningPopupResultSubscriber$ = subscriber;

      this.openWarningDialog(message);
    });
  }

  open$(): Observable<string> {
    return this._open$.asObservable();
  }

  private openWarningDialog(message: string): void {
    this._open$.next(message);
  }
}
